"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.number.constructor");
var _gift_card = require("@/api/community/gift_card.js");
var _GiftCardTracePane = _interopRequireDefault(require("./GiftCardTracePane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GiftCardListPane',
  components: {
    GiftCardTracePane: _GiftCardTracePane.default
  },
  props: {
    imgAccessDomain: {
      type: String,
      required: true
    },
    filterGiftCardFnId: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      total: 0,
      tableData: [],
      listQuery: {
        keywords: '',
        status: '',
        giftCardFnId: '',
        page: 1,
        limit: 20
      },
      giftCardOptions: [],
      traceDialogVisible: false,
      currentAssignMemId: null,
      currentCardInfo: {},
      imageDialogVisible: false,
      imageSaving: false,
      currentImageUrl: '',
      currentEditRow: null,
      uploadedImagePath: '',
      imageUploading: false
    };
  },
  watch: {
    filterGiftCardFnId: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.listQuery.giftCardFnId = val;
          this.search();
        }
      }
    }
  },
  created: function created() {
    this.loadGiftCardOptions();
    this.search();
  },
  methods: {
    loadGiftCardOptions: function loadGiftCardOptions() {
      var _this = this;
      (0, _gift_card.getGiftCardPage)({
        page: 1,
        limit: 999
      }).then(function (res) {
        _this.giftCardOptions = res.records || [];
      });
    },
    viewTrace: function viewTrace(row) {
      this.currentAssignMemId = row.fnId;
      this.currentCardInfo = {
        fnId: row.fnId,
        giftCardTitle: row.giftCardTitle,
        cardNo: row.cardNo,
        mobile: row.mobile,
        cardPrice: row.cardPrice,
        chargeType: row.chargeType,
        status: row.status
      };
      this.traceDialogVisible = true;
    },
    handleTraceClose: function handleTraceClose() {
      this.traceDialogVisible = false;
      this.currentAssignMemId = null;
      this.currentCardInfo = {};
    },
    editCardImage: function editCardImage(row) {
      this.currentEditRow = row;
      this.currentImageUrl = row.cardImage ? this.imgAccessDomain + row.cardImage : '';
      this.uploadedImagePath = row.cardImage || '';
      this.imageDialogVisible = true;
    },
    handleImageClose: function handleImageClose() {
      this.imageDialogVisible = false;
      this.currentEditRow = null;
      this.currentImageUrl = '';
      this.uploadedImagePath = '';
    },
    handleCardImageClick: function handleCardImageClick() {
      this.$refs.cardImageInput.click();
    },
    handleCardImageChange: function handleCardImageChange(event) {
      var files = event.target.files;
      if (files.length === 0) return;
      var file = files[0];
      if (this.validateCardImage(file)) {
        this.uploadCardImage(file);
      }
      event.target.value = '';
    },
    validateCardImage: function validateCardImage(file) {
      var isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    uploadCardImage: function () {
      var _uploadCardImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var response, data;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.imageUploading = true;
              _context.prev = 1;
              _context.next = 2;
              return (0, _gift_card.uploadGiftCardImage)(file);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                data = response.data;
                this.currentImageUrl = this.imgAccessDomain + data.pathKey;
                this.uploadedImagePath = data.pathKey;
                this.$message.success('图片上传成功!');
              }
            case 3:
              _context.prev = 3;
              this.imageUploading = false;
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function uploadCardImage(_x) {
        return _uploadCardImage.apply(this, arguments);
      }
      return uploadCardImage;
    }(),
    saveCardImage: function saveCardImage() {
      var _this2 = this;
      if (!this.uploadedImagePath) {
        this.$message.warning('请先上传卡面图片');
        return;
      }
      this.imageSaving = true;
      (0, _gift_card.updateMemberCardImage)({
        assignMemFnId: this.currentEditRow.fnId,
        cardImage: this.uploadedImagePath
      }).then(function () {
        _this2.$message.success('卡面更新成功');
        _this2.imageDialogVisible = false;
        _this2.currentEditRow.cardImage = _this2.uploadedImagePath;
        _this2.imageSaving = false;
      }).catch(function () {
        _this2.imageSaving = false;
      });
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    formatTime: function formatTime(val) {
      if (!val) return '';
      var d = new Date(val);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    },
    handleFilter: function handleFilter() {
      var _this3 = this;
      this.loading = true;
      (0, _gift_card.getGiftCardMemberPage)(this.listQuery).then(function (res) {
        _this3.tableData = res.records;
        _this3.total = res.total;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    }
  }
};